export default "__VITE_ASSET__CK$wZbIS__"